module.exports = __webpack_public_path__ + "static/table_intelligence-b464a448a28a06d17b7b7f4738e0aed1.jpg";